module.exports = __webpack_public_path__ + "static/media/_Poa.4c36d492.scss";


//////////////////
// WEBPACK FOOTER
// ./src/routes/Cob/views/Poa/_Poa.scss
// module id = 556
// module chunks = 0